import "../../assets/Stack.css";
import { jsx as m } from "react/jsx-runtime";
import { useResponsiveStyle as g } from "../../hooks/use-responsive-style.js";
const u = "_stack_myvqo_3", y = {
  stack: u
}, _ = ({
  children: o,
  className: l,
  spaceBetween: c
}) => {
  const i = (p) => `var(--el-core-space-${p})`, a = "margin-top", s = g(
    a,
    c,
    i
  ), [d, r, e, n] = s, t = s.slice(-1)[0];
  return /* @__PURE__ */ m("div", { className: l, children: /* @__PURE__ */ m(
    "div",
    {
      className: y.stack,
      style: {
        "--margin-default": d[a],
        "--margin-small-and-up": (r && r[a]) ?? t[a],
        "--margin-medium-and-up": (e && e[a]) ?? t[a],
        "--margin-large-and-up": (n && n[a]) ?? t[a]
      },
      children: o
    }
  ) });
};
export {
  _ as Stack
};
